import React, { useState } from "react";
import DateRangePicker from "../dashboard/DateRangePicker";
import { format, isToday, isValid, subDays, subHours } from "date-fns";
import { Accordion, Button, Col, Form } from "react-bootstrap";
import {
  DATE_FORMAT,
  EMPTY,
  LAST_HOURS,
  LAST_SEVEN_DAYS,
  LAST_THIRTY_DAYS,
} from "../../configurations/Constants";

function PrecipFilters({
  precipFilterOn,
  setPrecipFilterOn,
  setStartDateISO,
  setEndDateISO,
  setPrecipData,
  streetView,
  showWdpPanel,
}) {
  const [startDate, setStartDate] = useState(EMPTY);
  const [endDate, setEndDate] = useState(EMPTY);
  const [selectedRadioOption, setSelectedRadioOption] = useState(EMPTY);
  const [selectedHours, setSelectedHours] = useState(24);
  const [range, setRange] = useState({});
  const [datePopoverOpen, setDatePopoverOpen] = useState(false);
  const [customDateRangeClicked, setCustomDateRangeClicked] = useState(false);
  const [visibleMonths, setVisibleMonths] = useState(new Date());
  const handleRadioChange = (event) => {
    let { value } = event.target;
    setSelectedRadioOption(value);
    handleLastDaysFilters(value, selectedHours);
  };

  const handleSelectHoursChange = (event) => {
    let { value } = event.target;
    setSelectedHours(value);
    if (selectedRadioOption === LAST_HOURS) {
      handleLastDaysFilters(selectedRadioOption, value);
    }
  };
  const handleLastDaysFilters = (value, hours) => {
    const endTime = new Date();
    let startTime = new Date();
    switch (value) {
      case LAST_HOURS:
        startTime = subHours(endTime, hours);
        break;
      case LAST_SEVEN_DAYS:
        startTime = subDays(endTime, 7);
        break;
      case LAST_THIRTY_DAYS:
        startTime = subDays(endTime, 30);
        break;
      default:
        return;
    }
    setVisibleMonths(startTime);
    setRange({ from: startTime, to: endTime });
    setStartDate(format(startTime, DATE_FORMAT));
    setEndDate(format(endTime, DATE_FORMAT));
    setStartDateISO(convertToUtcTime(startTime));
    setEndDateISO(convertToUtcTime(endTime));
  };

  const handleDayClick = (day) => {
    if (selectedRadioOption || (range.from && range.to)) HandleClearDates();
    else if (!range.from) {
      // when start date is not selected
      setRange({ from: day, to: undefined });
      setStartDate(isValid(day) ? format(day, DATE_FORMAT) : EMPTY);
      setEndDate(EMPTY);
    } else if (range.from && !range.to) {
      // when start date is selected and end date is not selected
      let newRange = { ...range };
      if (day > range.from) {
        newRange.to = day;
        setEndDate(isValid(day) ? format(day, DATE_FORMAT) : EMPTY);
      } else {
        newRange = { from: day, to: range.from };
        setStartDate(isValid(day) ? format(day, DATE_FORMAT) : EMPTY);
        setEndDate(
          isValid(range.from) ? format(range.from, DATE_FORMAT) : EMPTY
        );
      }
      setDatePopoverOpen(false);
      if (isToday(newRange.to)) {
        // when end date is the current date (consider current time)
        const currentTime = new Date();
        newRange.to.setHours(
          currentTime.getHours(),
          currentTime.getMinutes(),
          currentTime.getSeconds()
        );
      }
      //for other end dates (consider full 24 hours)
      else newRange.to.setHours(23, 59, 59);
      setRange(newRange);
      setStartDateISO(convertToUtcTime(newRange.from));
      setEndDateISO(convertToUtcTime(newRange.to));
    }
  };

  const handleCustomDateRangeClicked = () => {
    setCustomDateRangeClicked(!customDateRangeClicked);
  };

  const handleClosePrecipFilter = () => {
    setPrecipFilterOn(!precipFilterOn);
    HandleClearPrecipFilter();
  };

  const HandleClearPrecipFilter = () => {
    setVisibleMonths(new Date());
    HandleClearDates();
    setPrecipData([]);
  };

  const HandleClearDates = () => {
    setStartDate(EMPTY);
    setEndDate(EMPTY);
    setRange({});
    setStartDateISO(EMPTY);
    setEndDateISO(EMPTY);
    setSelectedRadioOption(EMPTY);
    setSelectedHours(24);
  };

  const convertToUtcTime = (time) => {
    let utcTime = time.toISOString().split(".")[0];
    utcTime += "Z";
    return utcTime;
  };

  return (
    <div
      className={`precip-filter-box ${
        showWdpPanel && "precip-filter-box-right"
      } ${streetView && "precip-filter-box-dark"}`}
    >
      <div className="precip-filters">
        <div className="precip-filter-name ">
          <b>Precipitation Filter</b>
          <Form.Check
            type="switch"
            checked={precipFilterOn}
            onChange={() => handleClosePrecipFilter()}
          />
        </div>
        {precipFilterOn && (
          <>
            <div className="precip-filter-options">
              <div>
                <Form.Check
                  id="lastHoursCheck"
                  type="radio"
                  name="quickTimeFilter"
                  label={
                    <div>
                      Last
                      <select
                        value={selectedHours}
                        onChange={handleSelectHoursChange}
                        disabled={selectedRadioOption !== LAST_HOURS}
                        className="last-hours-check"
                      >
                        <option value={6}>6</option>
                        <option value={12}>12</option>
                        <option value={24}>24</option>
                      </select>
                      hours
                    </div>
                  }
                  value={LAST_HOURS}
                  checked={selectedRadioOption === LAST_HOURS}
                  className="precip-filter-box-option"
                  onChange={handleRadioChange}
                />
                <Form.Check
                  id="lastSevenDaysCheck"
                  type="radio"
                  name="quickTimeFilter"
                  label="Last 7 Days"
                  value={LAST_SEVEN_DAYS}
                  checked={selectedRadioOption === LAST_SEVEN_DAYS}
                  className="precip-filter-box-option"
                  onChange={handleRadioChange}
                />
                <Form.Check
                  id="lastThirtyDaysCheck"
                  type="radio"
                  name="quickTimeFilter"
                  label="Last 30 days"
                  value="lastThirtyDays"
                  checked={selectedRadioOption === "lastThirtyDays"}
                  className="precip-filter-box-option"
                  onChange={handleRadioChange}
                />
              </div>
              <div className="precip-filter-buttons">
                <span onClick={() => {}}>
                  <i
                    className="fa fa-close"
                    title="Reset Filter"
                    onClick={() => HandleClearPrecipFilter()}
                  ></i>
                </span>
              </div>
            </div>
            <Accordion className="w-100">
              <Accordion.Item eventKey="0">
                <Accordion.Header onClick={handleCustomDateRangeClicked}>
                  <span className={streetView && "dark-text"}>
                    Custom Date Range
                  </span>
                </Accordion.Header>
                <Accordion.Body>
                  <DateRangePicker
                    handleDayClick={handleDayClick}
                    startDate={startDate}
                    endDate={endDate}
                    range={range}
                    datePopoverOpen={datePopoverOpen}
                    setDatePopoverOpen={setDatePopoverOpen}
                    filterText={EMPTY}
                    disableAfter={true}
                    visibleMonths={visibleMonths}
                    setVisibleMonths={setVisibleMonths}
                  />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </>
        )}
      </div>
    </div>
  );
}

export default PrecipFilters;
